/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import { ByodDeviceData } from '@experience/shop/byod/interfaces/byod-landing.interface';
import { LineDeivceDetails } from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { ByodMappingModel } from '@experience/shop/product-selector/models/byod-mapping.model';
import { IsLineSetupCompletedModel } from '@experience/shop/product-selector/models/isLineSetupCompleted.model';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

export class ExtractByodDataModel {
  constructor() {}

  /**
   * Function used to extract data if coming from BYOD scenarios
   * @param {ByodDeviceData} byodModel
   * @param {LineDeivceDetails} currentLineDetails
   * @param {ObjectService} objectService
   * @param {string} simData
   * @returns {LineDeivceDetails}
   */
  public static extractByodData(
    byodModel: ByodDeviceData,
    currentLineDetails: LineDeivceDetails,
    objectService: ObjectService,
    simData?: string
  ): LineDeivceDetails {
    const focusedTileIdDetails = currentLineDetails;
    if (simData) {
      focusedTileIdDetails.byodSimData = ByodMappingModel.mapToSimDetails(simData);
    }
    focusedTileIdDetails.byodCMMOrImei = ByodMappingModel.mapToCareerMakeModelOrImei(
      byodModel,
      objectService
    );
    focusedTileIdDetails.isLineSetupCompleted = IsLineSetupCompletedModel.isLineSetupCompleted(
      focusedTileIdDetails,
      objectService
    );
    return focusedTileIdDetails;
  }
}
